import type { OpeningDay } from '@/types'

// Coordonnées de démonstration : à remplacer par celles du garage.
export const garage = {
    name: 'Garage Kermarec',
    shortName: 'Kermarec',
    founded: 2011,
    phone: {
        display: '02 61 91 44 18',
        href: 'tel:+33261914418',
        international: '+33261914418'
    },
    address: {
        street: '18 boulevard Gustave Roch',
        postalCode: '44200',
        city: 'Nantes',
        district: 'Île de Nantes'
    },
    geo: {
        lat: 47.20344,
        lon: -1.55202
    },
    rating: {
        value: 4.9,
        display: '4,9',
        count: 312
    },
    hourlyRate: 68,
    vatRate: 0.2
} as const

const toMinutes = (time: string): number => {
    const [hours, minutes] = time.split(':').map(Number)
    return hours * 60 + minutes
}

// Index de jour façon Date.getDay() : 0 = dimanche.
export const openingHours: OpeningDay[] = [
    { day: 1, label: 'Lundi', open: toMinutes('08:00'), close: toMinutes('19:00') },
    { day: 2, label: 'Mardi', open: toMinutes('08:00'), close: toMinutes('19:00') },
    { day: 3, label: 'Mercredi', open: toMinutes('08:00'), close: toMinutes('19:00') },
    { day: 4, label: 'Jeudi', open: toMinutes('08:00'), close: toMinutes('19:00') },
    { day: 5, label: 'Vendredi', open: toMinutes('08:00'), close: toMinutes('19:00') },
    { day: 6, label: 'Samedi', open: toMinutes('09:00'), close: toMinutes('13:00') },
    { day: 0, label: 'Dimanche', open: null, close: null }
]

export const directions = {
    google: `https://www.google.com/maps/dir/?api=1&destination=${garage.geo.lat},${garage.geo.lon}`,
    waze: `https://waze.com/ul?ll=${garage.geo.lat},${garage.geo.lon}&navigate=yes`,
    mapEmbed: `https://www.openstreetmap.org/export/embed.html?bbox=${garage.geo.lon - 0.012}%2C${garage.geo.lat - 0.006}%2C${garage.geo.lon + 0.012}%2C${garage.geo.lat + 0.006}&layer=mapnik`,
    osm: `https://www.openstreetmap.org/?mlat=${garage.geo.lat}&mlon=${garage.geo.lon}#map=17/${garage.geo.lat}/${garage.geo.lon}`
}

export const navLinks = [
    { href: '#tarifs', label: 'Tarifs', short: 'Tarifs' },
    { href: '#devis', label: 'Devis express', short: 'Devis' },
    { href: '#atelier', label: 'L’atelier', short: 'L’atelier' },
    { href: '#avis', label: 'Avis clients', short: 'Avis' },
    { href: '#equipe', label: 'L’équipe', short: 'L’équipe' },
    { href: '#contact', label: 'Accès et horaires', short: 'Accès' }
]
